import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import Card from '../component/component/receipe/Card'
function Receipe({ classes, title }) {
    const [input, setinput] = useState("")
    const [search, setsearch] = useState("chicken")
    const [receipeList, setreceipeList] = useState([])
    const [loading, setloading] = useState(true)
    const url = `https://api.edamam.com/search?q=${ search }&app_id=${ process.env.REACT_APP_ID }&app_key=${ process.env.REACT_APP_KEY }`;
    const receipe = async () => {
        const res = await fetch(url);
        const searchResult = await res.json();
        console.log(search)
        console.log(searchResult)
        console.log(loading)
        console.log(receipeList)
        setreceipeList([...searchResult.hits]);
        setloading(false)
    }
    useEffect(() => receipe(), [search])
    return (
        <>
            <h1 className={classes}>{title}</h1>

            <div className="container">
                <div className="row">
                    <div className="col s12">
                        <div className="card formCard">
                            <form onSubmit={e => {
                                e.preventDefault()
                                setsearch(input)
                            }}>
                                <div className="row">
                                    <div className="col l10 s12">
                                        <input type="text" onChange={(e) => {
                                            if ((e.target.value).length !== 0) {
                                                setloading(true)
                                                setinput(e.target.value)
                                            } else {
                                                setloading(false)
                                                setinput(e.target.value)
                                            }
                                        }} />
                                    </div>
                                    <div className="col l2 s12">
                                        <motion.button
                                            whileTap={{
                                                scale: 1.1,
                                                background: "blue",
                                                zIndex:0.6
                                            }}
                                            className="btn btn-large blue darken-4 right">
                                            <i className="material-icons">search</i>
                                        </motion.button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {
                        !loading ?
                            (receipeList.length !== 0) ?
                                receipeList.map((receipe, i) => {
                                    return <Card key={i} data={receipe} />
                                })
                                :
                                <h1 className="red-text">Nothing New Found...</h1>
                            :
                            <h1 className="blue-text">Loading...</h1>
                    }
                </div>
            </div>
        </>
    )
}

export default Receipe
